import Site, { UnitListingSortCriteria } from "@r6digital/rapidstor-types/types/Site";

export default interface Location {
  name: string;
  slug: string;
  locationId: number;
  locationCode: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  websiteUrl: string;
  latitude: number;
  longitude: number;
  timezoneOffset: number;
  address: {
    address1: string;
    address2: string;
    city: string;
    region: string;
    postalCode: string;
    country: string;
  };
  deleted: boolean;
  archived: boolean;
  rapidstorEnabled: boolean;
  token: string;
  createdAt: string;
  updatedAt: string;
  settings: {
    logo: string;
    groundFloor: number | string;
    groupUnitsByFloor: boolean;
    unitSortOrder: UnitListingSortCriteria[];
    billingDefault: string;
    sizeSymbol: string;
    areaSizeSymbol: string;
    allowMoveIn: boolean;
    showAreaInsteadOfDimensions: boolean;
  };
  rapidstor: {
    allowMoveIn: boolean;
    completeMoveinUrl: string;
    reservationNumberOfDaysInAdvanceLimit: number;
    includeReservedUnitsInOccupied: boolean;
    groundFloor: number;
  };
  hours: {
    officeMondayOpen: string;
    officeTuesdayOpen: string;
    officeWednesdayOpen: string;
    officeThursdayOpen: string;
    officeFridayOpen: string;
    officeSaturdayOpen: string;
    officeSundayOpen: string;
    officeMondayClose: string;
    officeTuesdayClose: string;
    officeWednesdayClose: string;
    officeThursdayClose: string;
    officeFridayClose: string;
    officeSaturdayClose: string;
    officeSundayClose: string;
  };
}

export const locationTransformer = (location: Site): Location => {
  const name = (location.friendlyName || location.sSiteName).replace(
    /^KeepSafe (Storage )?(- )?/i,
    ""
  );
  return <Location>{
    // This is not nice, but it's all we can do really
    name,
    slug: name
      .toLowerCase()
      .trim()
      .replace(/[\s_'-]+/g, "-")
      .replace(/[^\w\s-]/g, "")
      .replace(/^-+|-+$/g, ""),
    locationId: location.SiteID,
    locationCode: location.sLocationCode,
    contactName: location.sContactName,
    contactEmail: location.sEmailAddress,
    contactPhone: location.sSitePhone,
    websiteUrl: location.sWebSiteURL,
    latitude: parseFloat(location.dcLatitude),
    longitude: parseFloat(location.dcLongitude),
    timezoneOffset: location.iGMTTimeOffset,
    address: {
      address1: location.sSiteAddr1,
      address2: location.sSiteAddr2,
      city: location.sSiteCity,
      region: location.sSiteRegion,
      postalCode: location.sSitePostalCode,
      country: location.sSiteCountry,
    },
    rapidstor: {
      allowMoveIn: location.rapidstor.allowMoveIn,
      completeMoveinUrl: location.rapidstor.completeMoveinUrl,
      reservationNumberOfDaysInAdvanceLimit:
        location.rapidstor.reservationNumberOfDaysInAdvanceLimit,
      moveinNumberOfDaysInAdvanceLimit:
        location.rapidstor.moveinNumberOfDaysInAdvanceLimit,
      includeReservedUnitsInOccupied: location.rapidstor.includeReservedUnitsInOccupied,
      groundFloor: Number(location.rapidstor.groundFloor || 0),
    },
    deleted: location.deleted,
    archived: location.bArchived == "true",
    rapidstorEnabled: location.rapidstorEnabled,
    token: location.token,
    createdAt: location.dCreated,
    updatedAt: location.dUpdated,
    settings: {
      logo: location.rapidstor.siteLogo,
      groundFloor: location.rapidstor.groundFloor || 0,
      groupUnitsByFloor: location.rapidstor.unitListing.useMultilevel,
      billingDefault: location.rapidstor.billingDefault,
      sizeSymbol: location.rapidstor.sizeSymbol,
      areaSizeSymbol: location.rapidstor.areaSizeSymbol,
      allowMoveIn: location.rapidstor.allowMoveIn,
      showAreaInsteadOfDimensions: location.rapidstor.showAreaInsteadOfDimensions,
      unitSortOrder: [
        location.rapidstor.unitListing.sortOrder.primary,
        location.rapidstor.unitListing.sortOrder.secondary,
        location.rapidstor.unitListing.sortOrder.tertiary,
      ].filter((sortOrder) => sortOrder !== "none"),
    },
    hours: location.hours,
  };
};
